import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';

export const REVIEW_CHANGED_EVENT = 'review:changed';
export const notifyReviewChanged = () => window.dispatchEvent(new Event(REVIEW_CHANGED_EVENT));

// Conteo de registros pendientes de verificar (badge del menú). Se refresca al navegar y tras aprobar/rechazar.
export const usePendingReviewCount = (enabled, pathname) => {
  const [count, setCount] = useState(0);
  const load = useCallback(() => {
    if (!enabled) return;
    api.get('/review/pending-count', { silent: true, noCache: true }).then(({ data }) => setCount(data.count || 0)).catch(() => {});
  }, [enabled]);
  useEffect(() => { load(); }, [load, pathname]);
  useEffect(() => {
    window.addEventListener(REVIEW_CHANGED_EVENT, load);
    return () => window.removeEventListener(REVIEW_CHANGED_EVENT, load);
  }, [load]);
  return enabled ? count : 0;
};
